<template>
  <v-col :md="mini ? 4 : 8"
    :lg="mini ? 3 : 4">
    <v-card class="elevation-4 pa-2">
      <v-row>

        <v-col :md="3">
          <v-card :class="[`stats-card-icon`, color]" raised height="100%" style="height: 65px;min-width: 55px">
            <v-icon large dark class="pt-4">mdi-{{ icon }}</v-icon>
          </v-card>
        </v-col>

        <v-col :md="9">
          <div class="stats-content">
            <v-row  class="text-xs-right">
              <slot name="stats"></slot>
            </v-row>
          </div>

          <v-progress-linear :value="meter" height="2" :color="color">
          </v-progress-linear>

        </v-col>

      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'queue-top-stats-card',
  props: {
    icon: {
      type: String,
      default: 'help'
    },
    color: {
      type: String,
      default: 'primary'
    },
    meter: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      navMini: 'queues/getNavMini',
      showAgents: 'queues/agentsPaneShow'
    }),
    mini: function () {
      return (this.navMini && !this.showAgents)
    }
  }
}
</script>

<style scoped>
.header-icon { font-size: 48px; padding-top: 11px }
.stats-card-icon {
  margin-left: 0px;
  margin-top: -20px;
  width: 100%; height: 100%;
  text-align: center;
}
.stats-content {padding: 0 16px 0 0}
</style>
